<template>

  <v-navigation-drawer
    v-if="getData"
    class="white"
    v-model="barOpen"
    hide-overlay
    right
    floating
    absolute
    :width="barOpen ? barSize : 0"
    disable-resize-watcher
  >
    <scroll-area>
      <template slot="header">
        <v-toolbar  dense flat>
          <v-toolbar-title>
            <span class="body-2 text-uppercase">{{ getData.name }}</span>          
          </v-toolbar-title>
          <v-layout fill-height justify-end>
            <v-tooltip dark color="secondary" bottom>
              <v-btn icon flat slot="activator" 
              :data-testid="$options.name + '__btn__' + 'replace'"
              @click="dialog.replace.show = !dialog.replace.show">
                <svg-icon
                  :color="'primary'"
                  :name="'move'"
                  width="20"
                />
              </v-btn>
              <span>{{ $t('replace') }}</span>
            </v-tooltip>

            <v-tooltip dark color="secondary" bottom>
                <v-btn slot="activator" icon 
                :data-testid="$options.name + '__btn__' + 'delete'"
                @click="deleteLocation()"
                >
                  <svg-icon
                    :color="'red'"
                    :name="'basket'"
                    width="20"
                  />
                </v-btn>
                <span>{{$t('delete')}}</span>
            </v-tooltip>

            <v-tooltip dark color="secondary" bottom>
              <v-btn icon flat slot="activator" 
              :data-testid="$options.name + '__btn__' + 'update'" 
              @click="update()">
                <svg-icon
                  :color="'primary'"
                  :name="'done'"
                  width="20"
                />
              </v-btn>
              <span>{{ $t('save') }}</span>
            </v-tooltip>

            <v-tooltip dark color="secondary" bottom>
              <v-btn icon flat slot="activator" 
              :data-testid="$options.name + '__btn__' + 'close'"
              @click="close(); $store.dispatch('setEditMode', false)">
                <svg-icon
                  :color="'primary'"
                  :name="'close'"
                  width="20"
                />
              </v-btn>
              <span>{{ $t('cancel') }}</span>
            </v-tooltip>
          </v-layout>
        </v-toolbar>
      </template>

      <template slot="body">
        <v-container fluid fill-height ma-0 pa-0>
          <v-layout column fill-height>
            <v-tabs
              light
              v-model="panel"
              height="40px"
              left
            >
            <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>
              <v-tab
                class="font-weight-normal " 
                active-class="greytext--text"
                v-for="(place, index) in getPlaces"
                :data-testid="$options.name + '__' + place + '_tab__' + place"
                :key="index"
              >
                <template slot="default">
                  <div class="tab_wrapper">
                    <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                      {{ $t(place) }} 
                    </div>
                  </div>
                </template>
              </v-tab>
            </v-tabs>

            <v-form ref="location-form" style="height: 100%">
              <v-layout column v-for="(place, i) in getPlaces" :key="i" v-if="getPlaces[panel] == place" fill-height pa-1 ma-0>
                <v-layout column  v-show="place == 'main'" justify-start>
                  <v-layout shrink v-if="getFields" v-for="(field, index) in getFields" :key="[place] + field.name + 'text'">
                    <v-flex xs4 v-if="field.show == 'true' && field.type == 'text'&& field.place == place" shrink px-0 pb-2>

                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs8 v-if="field.show == 'true' && field.type == 'text'&& field.place == place" shrink px-0 pb-2>
                      <v-text-field
                        :data-testid="$options.name + '__' + place + '_text-field__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        auto-grow
                        :rules="field.name == 'name' ? [v => (v || '' ).length <= 35 || 'the number of characters in the name should not exceed', setErrorMessage] : []"
                        :error-messages="state.messages.error"
                        outline
                        class="white"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout shrink v-if="getFields" v-for="(field, index) in getFields" :key="[place] + field.name + 'select'">
                    <v-flex xs4 v-if="field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.place == place" shrink px-0 pb-2>
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs8 v-if="field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.place == place" shrink px-0 pb-2>
                      <v-select
                        :data-testid="$options.name + '__' + place + '_select__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-layout>

                <v-layout column fill-height v-show="place == 'main'" justify-start class="back">
                  <v-layout column fill-height justify-start>
                    <location-settings
                      v-if="barOpen"
                      :data="getData"
                      @access="(payload) => {onAccessChanged(payload)}"
                      @accessDetails="(payload) => {onAccessDetailsChanged(payload)}"
                      @changeChildren="(payload) => {onChildrenChange(payload)}"
                    />
                  </v-layout>
                </v-layout>
                
                <v-layout column fill-height v-if="place == 'main' && area == 'map'" justify-start>
                  <v-toolbar dense flat color="white">
                    <v-toolbar-title class="caption accent--text text-uppercase font-weight-normal font-condensend">{{$t('GEO binding')}}</v-toolbar-title>
                  </v-toolbar>
                  <v-layout column fill-height v-if="area == 'map'" justify-start >
                    <component
                      v-if="barOpen"
                      is="location-map"
                      :data="getData"
                      edit
                      :editMapCenter="true"
                      @change="(payload) => onCoordsChange(payload)"
                    />
                  </v-layout>

                  <!-- <v-layout column fill-height v-if="area == 'plan'" justify-start>
                    <file-image
                      ref="file-image-component"
                      :image="getPreview"
                      edit
                      @select="(payload) => {onPlanAdd(payload)}"
                    />
                  </v-layout> -->
                </v-layout>
              </v-layout>
            </v-form>
          </v-layout>
        </v-container>
      </template>
    </scroll-area>

    <v-dialog v-model="dialog.replace.show" max-width="50%" v-if="dialog.replace.show">
        <replace-card
          :data="getData"
          @close="dialog.replace.show = false"
        />
    </v-dialog>

  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import LocationMap from '@/nms/components/map/map.vue'
import LocationPlan from '@/nms/components/map/plan.vue'
import LocationSettings from '@/nms/pages/location/location-settings.vue'
import fileImage from '@/nms/components/partials/file-image.vue'
import replaceCard from '@/nms/pages/cabinet/replace-card.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface ModelData {
  fields: Record<string, any>
  items: Record<string, any>
  obj: Record<string, any>
  image: any | null
}

interface DialogState {
  replace: { show: boolean }
}

interface StateMessages {
  error: string
}

interface StateData {
  messages: StateMessages
}

interface LocationData {
  $id?: string
  name?: string
  [key: string]: any
}

interface FileItem {
  data?: {
    description?: string
  }
  [key: string]: any
}

interface UpdateLocationBarProps {
  open: boolean
  data: LocationData
  customPlaces?: string[]
}

interface CoordsPayload {
  latitude: number
  longitude: number
}

export default Vue.extend({
  name: 'UPDATE_LOCATION_BAR',

  components: {
    scrollArea,
    FormFileImport,
    LocationMap,
    LocationPlan,
    LocationSettings,
    fileImage,
    replaceCard,
    svgIcon
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Object as () => LocationData,
      default: () => ({})
    },
    customPlaces: {
      type: Array as () => string[],
      default: undefined,
    }
  },

  data(): {
    dataOnLoadId: string | null
    barOpen: boolean
    barSize: number
    panel: number
    dialog: DialogState
    model: ModelData
    state: StateData
    area: string
    files: FileItem[]
    meta: Record<string, any>
    preview: boolean
  } {
    return {
      dataOnLoadId: null,
      barOpen: false,
      barSize: 0,
      panel: 0,
      dialog: {
        replace: { show: false }
      },
      model: {
        fields: {},
        items: {},
        obj: {},
        image: null,
      },
      state: {
        messages: { error: '' }
      },
      area: 'plan',
      files: [],
      meta: {},
      preview: false,
    }
  },

  computed: {
    getData(): LocationData {
      return this.data
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getItems(): Record<string, any> {
      return this.model.items
    },

    getPlaces(): string[] {
      const userLevel = this.$store.state.auth.user?.level
      const places = this.customPlaces !== undefined 
        ? this.customPlaces 
        : this.$store.getters.getPlaces.update.location

      if (userLevel === 0) {
        return places
      } else {
        return places.filter(place => place !== 'settings')
      }
    },

    getPreview(): Array<{ url: string }> | any[] {
      if (this.preview) {
        return [{ url: this.preview }]
      } else {
        return this.getPlan
      }
    },

    getPlan(): FileItem[] {
      if (!this.files.length) return []
      return this.files.filter(file => file.data?.description === 'image_$')
    },
  },

  watch: {
    open: {
      handler(newVal: boolean): void {
        console.log('WATCH', this.$options.name, 'open', newVal)
        const barWrapper = this.$parent.$refs?.['barWrapper'] as HTMLElement
        if (barWrapper) {
          this.barSize = barWrapper.clientWidth
        }
        this.reset()
        if (newVal && this.data) {
          this.setup()
        }
        this.barOpen = newVal
      },
      deep: true
    },
    data: {
      handler(): void {
        this.reset()
        if (this.open) {
          this.setup()
        }
      },
      deep: true
    },
  },

  created(): void {
    if (this.open) {
      this.setup('created')
    }
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
    window.addEventListener('resize', this.resizeHandler)
  },

  updated(): void {
    if (this.open) {
      this.barOpen = this.open
    }
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
    window.removeEventListener('resize', this.resizeHandler)
  },

  methods: {
    setup(caller?: string): void {
      if (this.getData?.$id) {
        // if (this.dataOnLoadId === this.getData.$id) return
        this.dataOnLoadId = this.getData.$id
        this.loadFiles()
        this.loadMeta()
        // this.area = 'map'
      }
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.meta = await this.$loadMeta(this.getData)
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          this.prepareData()
        }
        this.setLoader('loadMeta', false)
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('loadMeta error', error)
      }
    },

    async prepareData(obj?: any): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta)
        // console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model
       
        if(this.model.fields.coordinates?.show == 'true') {
          this.area = 'map'
        }

      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('prepareData error', error)
      }
    },

    onCoordsChange(payload: CoordsPayload): void {
      const coords = {
        latitude: payload.latitude,
        longitude: payload.longitude
      }
      this.$set(this.model.obj, 'coordinates', coords)
    },

    onAccessChanged(payload: string): void {
      this.$set(this.model.obj, 'access', JSON.parse(payload))
    },

    onAccessDetailsChanged(payload: string): void {
      this.$set(this.model.obj, 'access_details', JSON.parse(payload))
    },

    onChildrenChange(payload: any[]): void {
      console.log(this.$options.name, 'onChildrenChange', 'payload', payload)
      this.$set(this.model.obj, 'children', payload)
    },

    async loadFiles(): Promise<void> {
      try {
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.getData.$id)
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    async update(): Promise<void> {
      this.$store.dispatch('setEditMode', false)
      
      const formRef = this.$refs['location-form'] as any
      const valid = formRef?.validate() ?? false
      
      if (!valid) {
        this.$dialog.notify.error(this.$getTranslate(this.state.messages.error), { timeout: 1000 })
        return
      }
      if (this.$store.state.auth.lock) return
      
      try {
        this.$store.state.auth.lock = true
        const data_$ = { ...this.model.obj }
        console.log(this.$options.name, 'update', 'data_$', data_$)

        const data$: Record<string, any> = {}
        Object.keys(data_$).forEach(key => {
          data$[key] = data_$[key] === undefined ? null : data_$[key]
        })
        
        if (this.model.image) {
          if (this.getPlan.length) {
            await this.$bridge.deleteDocument(this.getPlan[0].id)
          }
          data$.files = this.model.image
        }

        console.log(this.$options.name, 'update', 'data$', data$)
        this.setLoader('submitUpdateLocation', true)
        
        const $obj = await this.$bridge.getObjectById(this.getData.$id)
        if ($obj) {
          const u = await $obj.update(data$)
          console.log(this.$options.name, 'update', 'u', u)
          
          if (u) {
            this.$dialog.notify.success('Успешно обновлено', { timeout: 5000 })
            this.$bridge.litePolling(u.$id)
            this.$emit('update')
            this.setLoader('submitUpdateLocation', false)
            await this.$store.dispatch('updateObject', { $id: this.getData.$id })
            this.$store.state.auth.lock = false
          } else {
            this.$dialog.notify.error('Ошибка обновления', { timeout: 5000 })
            console.log('UPDATE-LOCATION-BAR', 'update', 'smth wrong', u)
            this.setLoader('submitUpdateLocation', false)
            await this.$store.dispatch('updateObject', { $id: this.getData.$id })
            this.$store.state.auth.lock = false
          }
        } else {
          console.log('UPDATE-LOCATION-BAR', 'update', '$obj', 'smth wrong', $obj)
          this.setLoader('submitUpdateLocation', false)
          this.$store.state.auth.lock = false
        }
      } catch (err) {
        console.error('CATCH', 'UPDATE-LOCATION-BAR', 'update', err)
        this.$errorHandler(err)
        this.setLoader('submitUpdateLocation', false)
        this.$store.state.auth.lock = false
      }
    },

    async deleteLocation(): Promise<void> {
      if (this.$store.state.auth.lock) return
      
      this.$dialog.confirm({
        text: `Удалить ${this.getData.name}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: async () => {
              this.$store.state.auth.lock = true
              try {
                this.setLoader('deleteLocation', true)
                const obj = await this.$bridge.getObjectById(this.getData.$id)
                let parent = await obj.getParent()
                console.log(this.$options.name, 'deleteLocation', 'parent', parent)

                let haveToUpdateTree = false

                if (!parent || parent.cls === 'folder') {
                  haveToUpdateTree = true
                  const p = this.$store.state.devices.tree?.find((item: any) => item.cls === 'location')
                  parent = p || undefined
                }
                
                const d = await obj.delete()
                if (d) {
                  await this.$store.dispatch('activeTree', parent)
                  if (haveToUpdateTree) {
                    await this.$store.dispatch('loadTree')
                  }
                  this.$emit('update')
                  this.setLoader('deleteLocation', false)
                  this.$store.state.auth.lock = false
                  this.$dialog.notify.success(this.$getTranslate('removal success'), { timeout: 5000 })
                } else {
                  console.log(this.$options.name, 'deleteLocation', 'smth wrong', d)
                  this.setLoader('deleteLocation', false)
                  this.$store.state.auth.lock = false
                  this.$dialog.notify.error(this.$getTranslate('delete error'), { timeout: 5000 })
                }
                this.$store.dispatch('setEditMode', false)
              } catch (err) {
                console.error('CATCH', this.$options.name, 'deleteLocation', err)
                this.$errorHandler(err)
                this.setLoader('deleteLocation', false)
                this.$store.state.auth.lock = false
              }
            }
          }
        }
      })
    },

    onPlanAdd(e: Event): void {
      const target = e.target as HTMLInputElement
      if (!target.files?.length) return
      
      this.preview = window.URL.createObjectURL(target.files[0])
      const file = target.files[0]
      file.data = this.$merge({}, { description: 'image_$' })
      this.$set(this.model, 'image', file)
    },

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
      }
    },

    resizeHandler(): void {
      const barWrapper = this.$parent.$refs?.['barWrapper'] as HTMLElement
      if (barWrapper) {
        this.barSize = barWrapper.clientWidth
      }
    },

    close(): void {
      this.reset()
      this.$emit('close')
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    setErrorMessage(e?: Event): boolean {
      if (this.model.obj.name && this.model.obj.name.length > 35) {
        const message = `${this.$getTranslate('the number of characters in the name should not exceed')} 35`
        this.state.messages.error = message
        return false
      } else {
        this.state.messages.error = ''
        return true
      }
    },

    reset(): void {
      this.panel = 0
      this.model = {
        fields: {},
        items: {},
        obj: {},
        image: null
      }
      this.area = 'plan'
      this.files = []
    },
  },
})
</script>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
